'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _logo = require('common/components/logo');

var _logo2 = _interopRequireDefault(_logo);

require('./simple-gray-layout.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * A top-level page layout component which tries to fill the entire page.
 * Features a simple header, a small centered card containing child content, and no footer.
 */
var SimpleGrayLayout = function (_React$Component) {
    _inherits(SimpleGrayLayout, _React$Component);

    function SimpleGrayLayout() {
        _classCallCheck(this, SimpleGrayLayout);

        return _possibleConstructorReturn(this, (SimpleGrayLayout.__proto__ || Object.getPrototypeOf(SimpleGrayLayout)).apply(this, arguments));
    }

    _createClass(SimpleGrayLayout, [{
        key: 'render',
        value: function render() {
            return _react2['default'].createElement(
                'div',
                { className: 'm-simple-gray-layout' },
                _react2['default'].createElement(_logo2['default'], { siteCode: 'S' }),
                _react2['default'].createElement(
                    'div',
                    { className: 'm-simple-gray-layout--card' },
                    this.props.children
                )
            );
        }
    }]);

    return SimpleGrayLayout;
}(_react2['default'].Component);

exports['default'] = SimpleGrayLayout;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/simple-gray-layout.jsx
 ** module id = 762
 ** module chunks = 0
 **/